<template>
<div>
  <div class="file-upload">
    <div
      class="wrap"
      @dragover="dragover"
      @dragleave="dragleave"
      @drop="drop"
      :class="{ 'active' : draggedOver }"
    >
      <input
        type="file"
        multiple
        ref="file"
        :name="name"
        :id="id"
        class="w-px h-px opacity-0 overflow-hidden absolute"
        @change="onChange"
        accept=".pdf,.jpg,.jpeg,.png"
      />

      <label :for="id" class="text">
        <img src="/images/upload.svg" alt="">
        <span>Click to upload or drag a file here</span>
      </label>

    </div>
  </div>
  <ul
    v-if="this.filelist.length"
    v-cloak
  >
    <li
      v-for="(file, index) in filelist"
      :key="index"
    >
      <span>{{ file.name }}</span>

      <div class="right">
        <span>{{ file.size | humanFileSize }}</span>
        <button
          @click="remove(filelist.indexOf(file))"
        >
          Remove
        </button>
      </div>
    </li>
  </ul>
</div>
</template>

<script>

export default {
  props: [
      'name', 'id'
  ],
  name: 'FormUpload',

  filters: {
    humanFileSize (size) {
      const i = !size ? 0 : Math.floor(Math.log(size) / Math.log(1024))
      return Math.round(size / Math.pow(1024, i)) + ' ' + ['b', 'kb', 'mb', 'gb', 'tb'][i]
    }
  },

  data () {
    return {
      filelist: [],
      draggedOver: false
    }
  },

  methods: {
    onChange () {
      this.filelist = [...this.$refs.file.files]
      this.$emit('newFiles', this.filelist)
    },

    remove (i) {
      this.filelist.splice(i, 1)
    },

    dragover (event) {
      event.preventDefault()
      // Add some visual fluff to show the user can drop its files
      this.draggedOver = true
    },

    dragleave (event) {
      this.draggedOver = false
    },

    drop (event) {
      event.preventDefault()
      this.$refs.file.files = event.dataTransfer.files
      this.onChange()
      this.draggedOver = false
    }
  }
}
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style lang="scss">
// .form-field.uploads {
//   width: 100%;
//   padding: 0x 0 30px;

//   .wrap {
//     padding: 20px;

//     text-align: center;

//     border: 1px solid #028678;
//     border-radius: 3px;
//     background-color: rgba(2, 134, 120, 0.02);

//     transition: all 0.2s ease-in-out;

//     input {
//       position: absolute;

//       width: 1px;
//       height: 1px;
//       margin: 0;
//       padding: 0;

//       overflow: hidden;
//       opacity: 0;
//     }

//     .message {
//       margin: 0;

//       font-size: 14px;
//       font-weight: 400;
//       line-height: 24px;
//       text-align: center;
//       cursor: pointer;
//       // color: $color-3;

//       img {
//         display: inline-block;
//         width: 16px;
//         margin: 0 6px 0 0;
//       }

//       // span { color: $color-1; }
//     }
//   }

//   .wrap.active {
//     background-color: rgba(2, 134, 120, 0.4);
//   }

  ul {
    margin: 10px 0 20px;
    padding: 0;

    // border-bottom: 1px solid $grey-2;

    li {
      display: flex;
      justify-content: space-between;

      font-size: 14px;
      font-weight: 400;
      // color: $color-2;

      .right {
        span {
          color: #9b9b9b;
        }
        button {
          margin-left: 12px;
          // color: $color-1;
        }
      }
    }
  }

//
// }
</style>



// WEBPACK FOOTER //
// resources/assets/frontend/js/components/FormUpload.vue